import React from "react";

function TotalWalletBalanceIcon({ fill = "#424242" }) {
  return (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6680_78009)">
        <rect
          y="-0.257812"
          width="51.3418"
          height="51.3418"
          rx="8.55696"
          fill="#DCFCE7"
        />
        <path d="M38 38H14V14H38V38Z" stroke="#10B77F" />
        <path
          d="M22 28C25.3137 28 28 25.3137 28 22C28 18.6863 25.3137 16 22 16C18.6863 16 16 18.6863 16 22C16 25.3137 18.6863 28 22 28Z"
          stroke="#22C55E"
          strokeWidth="1.90909"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.0901 24.3711C33.0354 24.7235 33.8765 25.3086 34.5358 26.0723C35.1951 26.836 35.6511 27.7535 35.8618 28.7402C36.0725 29.7268 36.031 30.7506 35.7411 31.7169C35.4513 32.6833 34.9224 33.5609 34.2035 34.2687C33.4846 34.9765 32.5988 35.4916 31.628 35.7663C30.6573 36.0411 29.633 36.0666 28.6497 35.8406C27.6665 35.6145 26.7562 35.1442 26.0029 34.4731C25.2496 33.802 24.6777 32.9518 24.3401 32.0011"
          stroke="#22C55E"
          strokeWidth="1.90909"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 20H22V24"
          stroke="#22C55E"
          strokeWidth="1.90909"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.7101 27.8789L31.4101 28.5889L28.5901 31.4089"
          stroke="#22C55E"
          strokeWidth="1.90909"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6680_78009">
          <rect
            width="51.3418"
            height="51.3418"
            fill="white"
            transform="translate(0 -0.257812)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default TotalWalletBalanceIcon;
